import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const bookingInquiryProfitItem = t.type({
  tax_excluded_total_price: t.number,
  excise_tax: t.number,
  tatekae_total_price: t.number,
});

export type BookingInquiryProfitItem = t.TypeOf<typeof bookingInquiryProfitItem>;

export const bookingInquiryProfit = t.type({
  invoice: h.omittable(bookingInquiryProfitItem),
  payment: h.omittable(bookingInquiryProfitItem),
});

export type BookingInquiryProfit = t.TypeOf<typeof bookingInquiryProfit>;

export const exampleBookingInquiryProfit: BookingInquiryProfit = {
  invoice: {
    tax_excluded_total_price: 20000,
    excise_tax: 2000,
    tatekae_total_price: 2200,
  },
  payment: {
    tax_excluded_total_price: 18000,
    excise_tax: 1800,
    tatekae_total_price: 2200,
  },
};
